import { render } from "./_LayoutHeader.vue?vue&type=template&id=13d18d7e&scoped=true"
import script from "./_LayoutHeader.vue?vue&type=script&lang=js"
export * from "./_LayoutHeader.vue?vue&type=script&lang=js"

import "./_LayoutHeader.vue?vue&type=style&index=0&id=13d18d7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d18d7e"]])

export default __exports__